import { render, staticRenderFns } from "./QuoteList.vue?vue&type=template&id=64c9296a&scoped=true&"
import script from "./QuoteList.vue?vue&type=script&lang=js&"
export * from "./QuoteList.vue?vue&type=script&lang=js&"
import style0 from "./QuoteList.vue?vue&type=style&index=0&id=64c9296a&scoped=true&lang=css&"
import style1 from "./QuoteList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c9296a",
  null
  
)

export default component.exports